import { useState } from "react";
import { Check } from "lucide-react";
import { api } from "../lib/api";
import { MaskLines } from "../components/site/Reveal";

const STEPS = ["Order placed", "Preparing", "Shipped", "Out for delivery", "Delivered"];
const field = "w-full border-b border-line bg-transparent py-3 text-base text-ink outline-none placeholder:text-graphite focus:border-ink";

export default function Track() {
  const [number, setNumber] = useState("");
  const [email, setEmail] = useState("");
  const [order, setOrder] = useState(null);
  const [error, setError] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setOrder(null);
    try {
      const { data } = await api.get("/orders/track", { params: { number: number.trim(), email: email.trim() } });
      setOrder(data);
    } catch {
      setError("We couldn't find an order with those details.");
    }
  };
  const step = Math.max(0, STEPS.indexOf(order?.status ?? "Order placed"));
  return (
    <div className="bg-ivory pb-24 pt-36 md:pt-44" data-testid="track-page">
      <div className="mx-auto max-w-3xl px-5 md:px-10">
        <p className="label-mono">Order tracking</p>
        <MaskLines as="h1" lines={["Where's my", <em key="t">MARKHOR?</em>]} className="mt-3 font-display text-5xl font-light leading-[0.95] text-ink md:text-7xl" />
        <form onSubmit={submit} className="mt-12 grid gap-6 md:grid-cols-[1fr_1fr_auto] md:items-end" data-testid="track-form">
          <input required placeholder="Order number (e.g. MKR-123456)" value={number} onChange={(e) => setNumber(e.target.value)} className={field} data-testid="track-number-input" />
          <input required type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className={field} data-testid="track-email-input" />
          <button className="btn-dark" data-testid="track-submit-button">Track</button>
        </form>
        {error && <p className="mt-6 text-sm text-[#9B1C1C]" data-testid="track-error">{error}</p>}
        {order && (
          <div className="mt-12 bg-white p-6 md:p-10" data-testid="track-result">
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-graphite">Order {order.order_number}</p>
            <p className="mt-2 font-display text-3xl text-ink" data-testid="track-status">{order.status}</p>
            <ol className="mt-8 space-y-5">
              {STEPS.map((s, i) => (
                <li key={s} className="flex items-center gap-4 text-sm">
                  <span className={`grid h-7 w-7 place-items-center rounded-full border ${i <= step ? "border-ink bg-ink text-ivory" : "border-line text-graphite"}`}>{i <= step ? <Check className="h-3.5 w-3.5" /> : i + 1}</span>
                  <span className={i <= step ? "text-ink" : "text-graphite"}>{s}</span>
                </li>
              ))}
            </ol>
          </div>
        )}
      </div>
    </div>
  );
}
